import { StatusRequiredAction} from "../state/status";
import {Input, InputAction} from "../state/input";
import {put, takeEvery, select} from "redux-saga/effects";
import equals from "fast-deep-equal";
import {AppState} from "../state";

export function *input () {

    let input: Input|null = null;

    yield takeEvery<InputAction>("Input", function * (action) {

        if (!equals(input, action.payload)) {
            input = action.payload;
            const appState: AppState = yield select();
            if (appState.status !== "STOPPED") {
                yield put<StatusRequiredAction>({
                    type: "RequiredStatus",
                    payload: "STOP"
                })
                yield put<StatusRequiredAction>({
                    type: "RequiredStatus",
                    payload: "PLAY"
                })
            }
        }
    });
}